<template>
	<div>
		<div class="columns">
			<div class="column is-5">
				<nav class="breadcrumb has-succeeds-separator has-text-weight-bold" aria-label="breadcrumbs">
					<ul>
						<li><a rel="noreferrer" :href="`/${this.sitelocale}`">{{t('home')}}</a></li>
						<template v-if="CategoryName=='allProducts'">
							<li class="is-active"><a rel="noreferrer" href="#" aria-current="page">{{t('all_products')}}</a></li>
						</template>
						<template v-else>
							<li><a rel="noreferrer" :href="`/${this.sitelocale}/categories`">{{t('all_categories')}}</a></li>
							<li class="is-active"><a rel="noreferrer" href="#" aria-current="page">{{CategoryName}}</a></li>
						</template>
					</ul>
				</nav>
			</div>
			<div class="column is-3">
				<!--<div class="field has-addons has-border-primary radius-md overflow-hidden">
					<div class="control is-expanded">
						<input class="input input-transparent has-text-primary rounded-input" type="text" placeholder="ابحث عن المجال الذي تريد الخصم به ">
					</div>
					<div class="control">
						<span class="select is-grey">
							<select>
								<option>{{t('category_name')}}</option>
								<option>£</option>
								<option>€</option>
							</select>
						</span>
					</div>
					<div class="control">
						<a rel="noreferrer" class="button has-right-border has-text-primary">
							<i class="fas fa-search"></i>
						</a>
					</div>
				</div>-->
			</div>
			<div class="column is-4">
				<div class="control is-expanded has-text-left">
					<div class="select is-rounded is-primary is-size-6">
						<select v-model="orderBy" name="category_filter">
							<option selected value="created_at">{{ t('last_added') }}</option>
							<option value="price_asc">{{ t('low_price') }}</option>
							<option value="price_desc">{{ t('high_price') }}</option>
							<option value="order_no">{{ t('order_no') }}</option>
						</select>
					</div>
				</div>
			</div>
		</div>
		<div v-infinite-scroll="loadNextPage" infinite-scroll-disabled="busy" infinite-scroll-distance="6">
			<div class="columns is-multiline is-multiline mt40 mb40 is-mobile">
				<div v-for="product in products" class="column is-2-desktop is-4-tablet is-6-mobile hvr-grow wow zoomIn" data-wow-duration="1s" data-wow-delay=".5s">
					<div class="position-relative card has-background-white overflow-hidden" data-aos="flip-left" data-aos-easing="linear" data-aos-duration="800">
						<a rel="noreferrer" :href="product.show_url" class="is-block">
							<div v-if="product.discount > 0" class="circle-radius has-background-warning circle-radius w-50 height-50 has-text-primary has-text-centered has-text-weight-bold">
								<span class="line-height50">{{ product.discount }}%</span>
							</div>
							<figure class="image height-150 image-cover mr-auto">
								<lazy-load
								:src="product.image"
								:lazy-src="product.image"
								:lazy-srcset="product.image"
								background-color="transparent"
								alt="slider"
								/>
							</figure>
							<div class="p20">
								<p class="has-text-primary has-text-centered mt5 has-text-weight-bold">{{ product.name }} </p>
								<star-rating class="mt10" v-bind:increment=".5"
								:read-only="true"
								:rating="product.rate"
								v-bind:max-rating="5"
								inactive-color="#ffffff"
								border-color="#f9ca2f"
								:border-width="2"
								active-color="#f9ca2f"
								v-bind:star-size="20" :rtl="sitelocale == 'ar' ? true : false">
							</star-rating>
							<div class="columns"  v-if="product.discount != 0">
								<div class="column is-6">
									<p class="has-text-warning has-text-centered has-text-weight-bold has-text-centered has-text-grey line-through">{{ product.price + t('currency') }} </p>
								</div>
								<div class="column is-6">
									<p class="has-text-warning has-text-centered has-text-weight-bold has-text-centered">{{ product.final_price + t('currency') }}  </p>
								</div>
							</div>
							<div class="columns" v-else>
								<div class="column is-12">
									<p class="has-text-warning has-text-centered has-text-weight-bold has-text-centered">{{ product.price + t('currency') }} </p>
								</div>
							</div>
						</div>
					</a>
					<a rel="noreferrer" :href="product.show_url" class="hvr-shutter-out-vertical is-block has-background-primary has-text-centered has-text-weight-bold has-text-warning p5">
						{{ t('show') }}
					</a>
				</div>
			</div>
		</div>
		<div class="has-text-centered" v-show="loadMore">
			<a rel="noreferrer" class="button is-primary hvr-shutter-out-vertical hvr-warning is-rounded p25 pr40 pl40" href="#">
				{{ t('load_more') }}
			</a>
		</div>
	</div>

</div>
</template>
<script>
	import axios from 'axios';
	import infiniteScroll from 'vue-infinite-scroll';
	import trans from '../translation/categories.json';
	export default {
		name: 'Products',
		directives: {
			infiniteScroll
		},
		props: {
			data: {
				type: Array,
				default: () => []
			},
			CategoryName:{
				type:String,
				required: true
			},
			url: String,
			sitelocale:{
				type:String,
				required: true
			}
		},
		computed: {
			busy() {
				return this.fetching
			}
		},
		mounted() {
			this.$translate.setLang(this.sitelocale);
		},
		locales: trans,
		data: () => ({
			products: [],
			order : [],
			currentPage: 0,
			fetching: false,
			nextUrl : String,
			loadMore : true,
			isActive: false,
			orderBy: 'created_at',
			filter: 'created_at'
		}),
		methods: {
			loadNextPage() {
				this.currentPage++;
				this.fetching = true;
				if(this.nextUrl != null){
					axios.get(this.nextUrl).then(({ data }) => {
						this.products.push(...data.data);
						if(data.links.next != null) {
							this.nextUrl = data.links.next;
						} else {
							this.nextUrl = data.links.next;
						}
						this.fetching = false;
					});
				}
				else{
					this.loadMore = false;
				}
			},
			getOrderBy(val) {
				if(val == 'price_asc') {
					this.sortOrder = 'asc';
					this.filter = 'final_price';
				} else if(val == 'price_desc') {
					this.sortOrder = 'desc';
					this.filter = 'final_price';
				} else {
					this.sortOrder = 'desc';
					this.filter = val;
				}
			}
		},
		created() {
			this.nextUrl = this.url;
			this.products = [];
			this.loadNextPage();
		},
		watch: {
			orderBy: function (val) {
				this.getOrderBy(val);
				this.products = [];
				axios.get(this.url, {
					params : {'orderBy' : this.filter, 'direction' : this.sortOrder}
				}
				).then(({data}) => {
					this.products = data.data;
					if(data.links.next != null) {
						this.loadMore = true;
						this.nextUrl = data.links.next;
					} else {
						this.nextUrl = data.links.next;
						this.loadMore = false;
					}
					this.currentPage = 0;
					this.fetching = false;
				});
			}
		}
	};
</script>
